import React from 'react';
import { ImageCard, Imgs }  from '../styles';

const ImageCardComponent = () => {
  return (
    <ImageCard>
      <img src={Imgs.encarte} alt="Horários e Feriados 2026" />
    </ImageCard>
  );
};

export default ImageCardComponent;
